import OaApiService from './OaApiService';

export default class CallService extends OaApiService {
  constructor(apiHandler) {
    super(apiHandler);
    this.createUrl = '/IninDiallerREST/create-call';
  }

  getCampaigns() {
    return this.get('/IninDiallerREST/call-campaigns');
  }

  createDiallerCall(data) {
    return this.post('/PureCloudDiallerREST/create-call', data);
  }
}
